import { roundToSeconds } from '@mi-front/core';
import { debug } from '../init/useInitializeStream';
import { useLoggerParams } from '../init/useLoggerParams';

/**
 * Hook to set the stream range (e.g. from datepicker).
 * Updates URL so the range is shareable and survives refresh.
 */
export function useLoadRange() {
  const [, setLoggerParams] = useLoggerParams();

  return (_from: number, _to: number) => {
    debug(
      'Load stream at %s (UTC: %s)',
      new Date(_from).toLocaleString(),
      new Date(_from).toUTCString(),
    );

    const from = roundToSeconds(_from);
    const to = roundToSeconds(_to);

    setLoggerParams({ from, to, cursor: null });
  };
}
